// Central business configuration.
// Update these values any time. WhatsApp number must be digits only (no +) for wa.me links.

export const SITE = {
  name: "GoCleaning Dublin",
  shortName: "GoCleaning",
  // ---- CONTACT CONFIGURATION (edit here) ----
  phoneDisplay: "089 946 7985",
  phoneHref: "+353899467985", // used in tel: links
  whatsappNumber: "353899467985", // digits only, no plus, for wa.me
  email: "moveoutcleaning28@gmail.com",
  // -------------------------------------------
  hours: {
    weekdays: "Monday to Saturday: 7:00 AM – 8:00 PM",
    sunday: "Sunday: By appointment",
  },
  serviceArea: "Dublin, County Kildare & surrounding areas",
  url: "https://gocleaning.ie",
  invoicesAvailable: true,
  // Google Business Profile Place ID — add later to connect real reviews.
  googlePlaceId: "", // e.g. "ChIJ..." leave empty until available
  googleReviewLink: "",
  // Related sister business (GoVans). Do NOT merge businesses — GoCleaning stays cleaning-focused.
  goVans: {
    url: "https://govans.ie",
    // Paste the GoVans Google reviews link here to activate the reviews button.
    reviewsUrl: "https://www.google.com/maps/place/GoVans.ie+provides+Man+With+A+Van,+house+removals,+moving+and+delivery+services+across+Dublin+and+Kildare/@53.3335,-6.2701572,17z/data=!3m1!4b1!4m6!3m5!1s0x486771e0aa8c5d11:0xe767b97b0ea8e9a3!8m2!3d53.3335!4d-6.2701572!16s%2Fg%2F11njcyqg3c!18m1!1e1?entry=ttu",
  },
  // Analytics IDs — leave empty until provided. Loaded in public/index.html.
  gaMeasurementId: "", // e.g. "G-XXXXXXX"
  gtmId: "", // e.g. "GTM-XXXXXXX"
};

export const defaultWhatsAppMessage =
  "Hello, I would like a quote for end-of-tenancy cleaning. The property is located in [AREA]. It has [NUMBER] bedrooms and [NUMBER] bathrooms. My preferred date is [DATE].";

export function whatsappLink(message = defaultWhatsAppMessage) {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export function telLink() {
  return `tel:${SITE.phoneHref}`;
}

export function mailLink(subject = "End of tenancy cleaning quote") {
  return `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}`;
}
